import { useMemo } from "react"
import {
  HomeRegistrationsQueryVariables,
  OrderByDir,
  PositioningContextTypeInput
} from "@pathwright/graphql-client/src/generated"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"

// This is really just a stop-gap to share vars with other queries
export const useHomeRegistrationVars = (): HomeRegistrationsQueryVariables => {
  const { me } = usePathwrightContext()

  return useMemo(
    () => ({
      first: 1042,
      positioningContext: {
        contextType: PositioningContextTypeInput.HomeScreen,
        contextKey: `user:${me.id}`
      },
      orderBy: [{ position: OrderByDir.Asc }, { created: OrderByDir.Asc }],
      softArchived: { eq: null }
      // progressFilter: { neq: 1 }
    }),
    [me.id]
  )
}

export const useHomeSoftArchivedRegistrationVars =
  (): HomeRegistrationsQueryVariables => {
    const { me } = usePathwrightContext()

    return useMemo(
      () => ({
        first: 1042,
        positioningContext: {
          contextType: PositioningContextTypeInput.HomeScreen,
          contextKey: `user:${me.id}`
        },
        orderBy: [{ created: OrderByDir.Asc }],
        softArchived: { neq: null }
      }),
      [me.id]
    )
  }

// export const useHomeCompletedRegistrationVars =
//   (): HomeRegistrationsQueryVariables => {
//     return {
//       first: 1042,
//       orderBy: [{ created: OrderByDir.Asc }],
//       softArchived: { eq: null },
//       progressFilter: { eq: 1 }
//     }
//   }
